import { useCallback, useMemo } from 'react'
import { IOS_APP_STORE_LINK, ANDROID_PLAY_STORE_LINK } from 'constants/appStores'
import { isNativeNoOverride, isIphoneNative, isAndroidNative } from 'utils/platform'
import { VERSION_REQUIREMENT_TRANSLATIONS } from '../constants'

const useVersionRequirement = (dismiss: () => void) => {
  const callback = useCallback(() => {
    if (isNativeNoOverride()) {
      if (isIphoneNative()) {
        window.location.href = IOS_APP_STORE_LINK
      }
      if (isAndroidNative()) {
        window.location.href = ANDROID_PLAY_STORE_LINK
      }
    } else {
      window.location.reload()
    }

    dismiss()
  }, [dismiss])

  const callToAction = useMemo(
    () => (isNativeNoOverride() ? VERSION_REQUIREMENT_TRANSLATIONS.update : VERSION_REQUIREMENT_TRANSLATIONS.reload),
    [],
  )

  return { callback, callToAction }
}

export default useVersionRequirement
